<template>
<section :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}, 'section']" :id="block.anchor ? block.anchor : ('block-' + block.id)" :style="`--item-width: ${itemWidth()};`">
    <div class="container has-text-centered">
        <h2 class="title">{{block.title}}</h2>
        <div class="content" ref="content" v-html="block.content"></div>
        <div class="isotope-filters">
            <button
                :class="['button is-primary', {'is-outlined': selectedTag && selectedTag.id !== 'all'}]"
                @click="filter({id: 'all'})"
            >All</button>
            <button
                v-for="tag in tags"
                class="button"
                @click="filter(tag)"
                :class="['button is-primary', {'is-outlined': !selectedTag || tag.id !== selectedTag.id}]"
            >{{ tag.title }}</button>
        </div>
        <isotope
            class="isotope-items"
            ref="cpt"
            :options="options"
            :list="list"
            :item-selector="'isotope-item'"
        >
          <div v-for="client in list" :key="client.id">
            <component
                :is="client.website ? 'a' : 'div'"
                :href="client.website && client.website.url ? client.website.url : null"
                :target="client.website ? '_blank' : null"
                class="isotope-item__core"
            >
                <img v-if="client.logo && client.logo.url" ref="clientLogos" :src="client.logo.url" :alt="client.title" />
                <span v-else>{{ client.title }}</span>
            </component>
          </div>
        </isotope>
    </div>
</section>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
import isotope from 'vueisotope'
require('isotope-cells-by-row')

export default {
    name        :   'ClientOverviewBlock',
    mixins      :   [ BlockCommons ],
    components  :   { isotope },
    data() {
        return {
            actualWidth: 0,
            selectedTag: null,
            filterOption: 'All',
            options: {
              layoutMode: 'cellsByRow',
              itemSelector: ".element-item",
              getFilterData: {
                all: () => {
                  return true;
                },
                filterByTag: el => {
                  return el.industries.find(o => o.id == this.selectedTag.id)
                }
              },
            }
        }
    },
    computed    :   {
        list() {
            if (this.block && this.block.clients) {
                return this.block.clients
            }

            return []
        },
        tags() {
            if (this.block && this.block.clients) {
                const industries = this.block.clients.map(client => {
                    return client.industries
                })

                const unique = []
                industries.flat().forEach(item => {
                    if (!unique.find(o => o.id == item.id)) {
                        unique.push(item)
                    }
                })


                return unique
            }

            return []
        }
    },
    mounted() {
        this.$refs.clientLogos.forEach(logo => {
            logo.addEventListener('load', () => {
                this.filter({id: 'all'})
            })
        })

        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
            this.filter({id: 'all'})
        })
    },
    methods: {
        filtered() {
            if (!this.selectedTag || this.selectedTag.id == 'all') {
                return this.block.clients.length
            }

            return this.block.clients.filter(o => {
                return o.industries.find(j => j.id == this.selectedTag.id)
            })
        },
        itemWidth() {
            return '20%'

            let count = this.filtered().length

            if (count == 1)  {
                return '100%'
            }

            return '20%'
        },
        filter(tag) {
            this.selectedTag = tag
            this.$refs.cpt.filter(tag.id === 'all' ? 'all' : 'filterByTag')
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/ClientOverviewBlock.vue